import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-restricted-imports */
import { useEffect, useState } from 'react';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { Input } from '@tribeplatform/react-ui-kit/Input';
import { GridList } from '@tribeplatform/react-ui-kit/Layout';
import { toast } from '@tribeplatform/react-ui-kit/Toast';
import { useDebounce } from '../../common/hooks/useDebounce';
import * as unsplash from '../../common/lib/unsplash';
import { T, useI18n } from '../../i18n';
import { UnsplashItem } from './UnsplashItem';
export const UnsplashPicker = ({ onChange, defaultQuery = '', apiKey, }) => {
    const intl = useI18n();
    const [query, setQuery] = useState(defaultQuery);
    const [loading, setLoading] = useState(true);
    const [images, setImages] = useState();
    const debouncedSearchTerm = useDebounce(query, 500);
    // get some random image on cdm
    useEffect(() => {
        setLoading(true);
        unsplash
            .random(apiKey, {
            orientation: 'landscape',
        })
            .then(result => {
            var _a;
            if (result.type === 'success') {
                const _images = (_a = result.response) === null || _a === void 0 ? void 0 : _a.map(r => {
                    var _a, _b, _c, _d;
                    return ({
                        url: (_a = r === null || r === void 0 ? void 0 : r.urls) === null || _a === void 0 ? void 0 : _a.small,
                        id: r === null || r === void 0 ? void 0 : r.id,
                        creator: (_b = r === null || r === void 0 ? void 0 : r.user) === null || _b === void 0 ? void 0 : _b.name,
                        username: (_c = r === null || r === void 0 ? void 0 : r.user) === null || _c === void 0 ? void 0 : _c.username,
                        color: r === null || r === void 0 ? void 0 : r.color,
                        downloadLocation: (_d = r === null || r === void 0 ? void 0 : r.links) === null || _d === void 0 ? void 0 : _d.download_location,
                    });
                });
                setImages(_images);
            }
        })
            .finally(() => {
            setLoading(false);
        });
    }, [apiKey]);
    // query photos
    useEffect(() => {
        if (debouncedSearchTerm) {
            setLoading(true);
            unsplash
                .search(apiKey, debouncedSearchTerm, { orientation: 'landscape' })
                .then(result => {
                var _a;
                if (result.type === 'success') {
                    const _images = (_a = result.response.results) === null || _a === void 0 ? void 0 : _a.map(r => {
                        var _a, _b, _c, _d;
                        return ({
                            url: (_a = r === null || r === void 0 ? void 0 : r.urls) === null || _a === void 0 ? void 0 : _a.small,
                            id: r === null || r === void 0 ? void 0 : r.id,
                            creator: (_b = r === null || r === void 0 ? void 0 : r.user) === null || _b === void 0 ? void 0 : _b.name,
                            username: (_c = r === null || r === void 0 ? void 0 : r.user) === null || _c === void 0 ? void 0 : _c.username,
                            color: r === null || r === void 0 ? void 0 : r.color,
                            downloadLocation: (_d = r === null || r === void 0 ? void 0 : r.links) === null || _d === void 0 ? void 0 : _d.download_location,
                        });
                    });
                    setImages(_images);
                }
            })
                .finally(() => {
                setLoading(false);
            });
        }
    }, [apiKey, debouncedSearchTerm]);
    const onClick = async (image) => {
        setLoading(true);
        try {
            const url = await unsplash.downloadPhoto(apiKey, image.downloadLocation);
            onChange === null || onChange === void 0 ? void 0 : onChange(url);
        }
        catch (e) {
            toast({
                title: intl.$t({
                    id: 'Generics.SomethingWentWrong',
                    defaultMessage: 'Something went wrong',
                }),
                status: 'error',
            });
            setLoading(false);
        }
    };
    return (_jsxs("div", { className: "relative h-80 mx-auto flex flex-col gap-4", children: [_jsx(Input, { placeholder: intl.$t({
                    id: 'Picker.UnsplashPicker.SearchInputPlaceholder',
                    defaultMessage: 'Search for an image...',
                }), value: query, onChange: e => { var _a; return setQuery((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); } }, void 0), loading && (_jsx("div", { className: "absolute inset-0 flex bg-background-overlay", children: _jsx(SpinnerIcon, { className: "animate-spin h-7 w-7 m-auto" }, void 0) }, void 0)), (images === null || images === void 0 ? void 0 : images.length) > 0 && (_jsx(GridList, { className: "gap-2 overflow-auto", columns: 3, children: images === null || images === void 0 ? void 0 : images.map(image => (_jsx(GridList.Item, { children: _jsx(UnsplashItem, { image: image, onClick: onClick }, void 0) }, image.id))) }, void 0)), (images === null || images === void 0 ? void 0 : images.length) === 0 && !loading && (_jsx("div", { className: "text-sm flex justify-center items-center text-content-subdued", children: _jsx(T, { id: "Picker.UnsplashPicker.NotResultsFound", defaultMessage: "No results found." }, void 0) }, void 0))] }, void 0));
};
//# sourceMappingURL=Picker.js.map